import * as React from "react";
import { makeStyles, createStyles } from "@material-ui/core";

type Props = {
    children?: any;
    /**
     * The width divided by the height. This ratio can be passed in
     * using JavaScript division syntax. So, to get a 16:9 ratio,
     * simply pass `ratio={16/9}`.
     */
    // eslint-disable-next-line react/no-unused-prop-types
    ratio: number;
};

const useStyles = makeStyles(() =>
    createStyles({
        outerWrapper: (props: Props) => ({
            position: "relative",
            width: "100%",
            height: 0,
            paddingBottom: `${(1 / props.ratio) * 100}%`,
        }),
        innerWrapper: {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
    }),
);

export function AspectRatio(props: Props) {
    const classes = useStyles(props);

    return (
        <div className={classes.outerWrapper}>
            <div className={classes.innerWrapper}>{props.children}</div>
        </div>
    );
}
